export { DiscountBanner } from './DiscountBanner';
